import {ReactElement} from "react"

const BoatDimensionsIcon = ():ReactElement => {
	return (
    <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.30558 16.3364L6.46354 14.4944M11.0686 13.5733L9.2266 11.7313M13.8317 10.8103L11.9897 8.96823M16.5948 8.04721L14.7527 6.20517M6.67421 19.5685L19.5685 6.67421C20.0772 6.16554 20.0772 5.34083 19.5685 4.83216L15.8678 1.1315C15.3592 0.622834 14.5345 0.622834 14.0258 1.1315L1.1315 14.0258C0.622834 14.5345 0.622833 15.3592 1.1315 15.8678L4.83216 19.5685C5.34083 20.0772 6.16554 20.0772 6.67421 19.5685Z"
        stroke="#4B90C6"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default BoatDimensionsIcon
